var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTable)?_c('span',[((_vm.fileType == 'ofd' || _vm.fileType == 'OFD') && !_vm.fileFail)?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_txt.svg")}}):_vm._e(),_vm._v(" "),((_vm.fileType == 'ofd' || _vm.fileType == 'OFD') && _vm.fileFail)?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/ofd_pl.svg")}}):_vm._e(),_vm._v(" "),((_vm.fileType == 'pdf' || _vm.fileType == 'PDF') && !_vm.fileFail)?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_pdf.svg")}}):_vm._e(),_vm._v(" "),((_vm.fileType == 'pdf' || _vm.fileType == 'PDF') && _vm.fileFail)?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/pdf_pl.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'doc' ||
        _vm.fileType == 'docx' ||
        _vm.fileType == 'DOC' ||
        _vm.fileType == 'DOCX') &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_doc.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'doc' ||
        _vm.fileType == 'docx' ||
        _vm.fileType == 'DOC' ||
        _vm.fileType == 'DOCX') &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_doc_fail.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'xlsx' ||
        _vm.fileType == 'xls' ||
        _vm.fileType == 'XLSX' ||
        _vm.fileType == 'XLS') &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_excel.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'xlsx' ||
        _vm.fileType == 'xls' ||
        _vm.fileType == 'XLSX' ||
        _vm.fileType == 'XLS') &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_excel_fail.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'jpg' ||
        _vm.fileType == 'JPG' ||
        _vm.fileType == 'png' ||
        _vm.fileType == 'PNG' ||
        _vm.fileType == 'tif' ||
        _vm.fileType == 'TIF' ||
        _vm.fileType == 'tiff' ||
        _vm.fileType == 'TIFF' ||
        _vm.fileType == 'bmp' ||
        _vm.fileType == 'BMP') &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_jpg.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'jpg' ||
        _vm.fileType == 'JPG' ||
        _vm.fileType == 'png' ||
        _vm.fileType == 'PNG' ||
        _vm.fileType == 'tif' ||
        _vm.fileType == 'TIF' ||
        _vm.fileType == 'tiff' ||
        _vm.fileType == 'TIFF' ||
        _vm.fileType == 'bmp' ||
        _vm.fileType == 'BMP') &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/img_pl.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'ppt' ||
        _vm.fileType == 'pptx' ||
        _vm.fileType == 'PPT' ||
        _vm.fileType == 'PPTX') &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_ppt.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'ppt' ||
        _vm.fileType == 'pptx' ||
        _vm.fileType == 'PPT' ||
        _vm.fileType == 'PPTX') &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_ppt_fail.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'wps' ||
        _vm.fileType == 'WPS') &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_wps.svg")}}):_vm._e(),_vm._v(" "),(
      (_vm.fileType == 'wps' ||
        _vm.fileType == 'WPS') &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_wps_fail.svg")}}):_vm._e(),_vm._v(" "),(
      ((_vm.fileType != 'ofd' &&
        _vm.fileType != 'OFD' &&
        _vm.fileType != 'pdf' &&
        _vm.fileType != 'PDF' &&
        _vm.fileType != 'doc' &&
        _vm.fileType != 'DOC' &&
        _vm.fileType != 'docx' &&
        _vm.fileType != 'DOCX' &&
        _vm.fileType != 'xlsx' &&
        _vm.fileType != 'XLSX' &&
        _vm.fileType != 'xls' &&
        _vm.fileType != 'XLS' &&
        _vm.fileType != 'jpg' &&
        _vm.fileType != 'JPG' &&
        _vm.fileType != 'png' &&
        _vm.fileType != 'PNG' &&
        _vm.fileType != 'tif' &&
        _vm.fileType != 'TIF' &&
        _vm.fileType != 'tiff' &&
        _vm.fileType != 'TIFF' &&
        _vm.fileType != 'bmp' &&
        _vm.fileType != 'BMP'&&
        _vm.fileType != 'ppt' &&
        _vm.fileType != 'PPT' &&
        _vm.fileType != 'pptx' &&
        _vm.fileType != 'wps' &&
        _vm.fileType != 'WPS' &&
        _vm.fileType != 'PPTX')||_vm.fileType == 'gif'||_vm.fileType == 'GIF'||
        !_vm.fileType) &&
      !_vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_other.svg")}}):_vm._e(),_vm._v(" "),(
      ((_vm.fileType != 'ofd' &&
        _vm.fileType != 'OFD' &&
        _vm.fileType != 'pdf' &&
        _vm.fileType != 'PDF' &&
        _vm.fileType != 'doc' &&
        _vm.fileType != 'DOC' &&
        _vm.fileType != 'docx' &&
        _vm.fileType != 'DOCX' &&
        _vm.fileType != 'xlsx' &&
        _vm.fileType != 'XLSX' &&
        _vm.fileType != 'xls' &&
        _vm.fileType != 'XLS' &&
        _vm.fileType != 'jpg' &&
        _vm.fileType != 'JPG' &&
        _vm.fileType != 'png' &&
        _vm.fileType != 'PNG' &&
        _vm.fileType != 'tif' &&
        _vm.fileType != 'TIF' &&
        _vm.fileType != 'tiff' &&
        _vm.fileType != 'TIFF' &&
        _vm.fileType != 'bmp' &&
        _vm.fileType != 'BMP'&&
        _vm.fileType != 'ppt' &&
        _vm.fileType != 'PPT' &&
        _vm.fileType != 'pptx' &&
        _vm.fileType != 'wps' &&
        _vm.fileType != 'WPS' &&
        _vm.fileType != 'PPTX')||_vm.fileType == 'gif'||_vm.fileType == 'GIF'||
        !_vm.fileType) &&
      _vm.fileFail
    )?_c('img',{staticClass:"icon",class:{ isSeach: _vm.isSeach },attrs:{"src":require("@comm/images/document-conversion/icon_other_fail.svg")}}):_vm._e()]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707101dd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/document-conversion/iconImg/index.vue
// module id = null
// module chunks = 